import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const SectionTitle = ({ className, title }) => {
  if (!title) {
    return null;
  }

  const classes = cn('LessonHeader-sectionTitle mt-16 wb-ba ws-pr', className);

  return (
    <Text
      component="h2"
      variant={TEXT_VARIANTS.SUBHEADER_BOLD}
      className={classes}
    >
      {title}
    </Text>
  );
};

SectionTitle.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
};

export default props => <SectionTitle {...props} />;
